import { enqueueSnackbar } from "notistack"

// project-imports
import useConfig from "hooks/useConfig"
import axios from "utils/axios"

// types
import { ThemeMode } from "types/config"

// ==============================|| HOOKS - THEME MODE ||============================== //

// Theme mode is a per-user preference: it is applied immediately and saved on the account,
// so the next login on any device starts in the same mode.
const useThemeMode = () => {
  const { mode, onChangeMode } = useConfig()
  const isDark = mode === ThemeMode.DARK

  const changeThemeMode = async (newMode: ThemeMode) => {
    if (newMode === mode) return

    const previousMode = mode
    onChangeMode(newMode)

    try {
      await axios.put(`/users/update_theme_mode/`, { theme_mode: newMode })
    } catch (err) {
      onChangeMode(previousMode)
      enqueueSnackbar(`Error saving theme preference`, {
        variant: "error",
        preventDuplicate: true,
        anchorOrigin: { vertical: "top", horizontal: "right" }
      })
    }
  }

  const toggleThemeMode = () => changeThemeMode(isDark ? ThemeMode.LIGHT : ThemeMode.DARK)

  return { mode, isDark, changeThemeMode, toggleThemeMode }
}

export default useThemeMode
